import { render, staticRenderFns } from "./SignedIcon.vue?vue&type=template&id=239c05c2&scoped=true&"
import script from "./SignedIcon.vue?vue&type=script&lang=ts&"
export * from "./SignedIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SignedIcon.vue?vue&type=style&index=0&id=239c05c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239c05c2",
  null
  
)

export default component.exports